import { render } from "./AdminActivityLogs.vue?vue&type=template&id=b585a1ec&scoped=true"
import script from "./AdminActivityLogs.vue?vue&type=script&lang=js"
export * from "./AdminActivityLogs.vue?vue&type=script&lang=js"

import "./AdminActivityLogs.vue?vue&type=style&index=0&id=b585a1ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b585a1ec"]])

export default __exports__